import React from 'react';
import { CircularProgress } from '@mui/material';
import './ButtonGlass.css';

const ButtonGlass = ({ children, onClick, icon, iconComponent, disabled, loading }) => {
  return (
    <button
      className={`button-glass ${disabled || loading ? 'button-glass-disabled' : ''}`}
      onClick={disabled || loading ? undefined : onClick}
      disabled={disabled || loading}
    >
      {loading ? (
        <CircularProgress size={20} sx={{ color: '#FFF' }} />
      ) : icon ? (
        <img
          src={icon}
          alt="icon"
          draggable={false}
          onContextMenu={(e) => e.preventDefault()}
          onDragStart={(e) => e.preventDefault()}
          className={`button-icon ${disabled ? 'button-icon-disabled' : ''}`}
        />
      ) : iconComponent ?? null}
      {children}
    </button>
  );
};

export default ButtonGlass;